/**
 * Card Variant Selector Functionality
 * Updates price and variant when user selects different options
 */

// Legacy variant selector for price updates only (non-direct-add-to-cart selectors)
function initCardVariantSelectors() {
  const variantSelects = document.querySelectorAll('.card-variant-select:not([data-update-form="true"])');
  
  variantSelects.forEach((select) => {
    // Skip if already has listeners
    if (select.dataset.initialized) return;
    
    select.addEventListener('change', function(event) {
      updateCardVariantPrice(this);
    });
    
    select.dataset.initialized = 'true';
  });
}

// Legacy price update function for non-direct-add-to-cart selectors
function updateCardVariantPrice(selectElement) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  if (!selectedOption) return;
  
  const variantPrice = selectedOption.dataset.variantPrice;
  const variantComparePrice = selectedOption.dataset.variantComparePrice;
  
  if (!variantPrice) return;
  
  const cardContainer = selectElement.closest('.card-wrapper') ||
                       selectElement.closest('.card') ||
                       selectElement.closest('.grid__item') ||
                       selectElement.closest('.slider__slide');
  
  if (!cardContainer) return;
  
  // Format prices
  const priceInCents = parseInt(variantPrice);
  const priceInPesos = Math.round(priceInCents / 100);
  const formattedPrice = '$' + priceInPesos.toLocaleString('es-CL') + ' CLP';
  
  // Find the price container
  const priceContainer = cardContainer.querySelector('.price');
  if (!priceContainer) return;
  
  // Check if product is on sale (price__sale is visible)
  const saleContainer = priceContainer.querySelector('.price__sale');
  const regularContainer = priceContainer.querySelector('.price__regular');
  
  const isOnSale = saleContainer && window.getComputedStyle(saleContainer).display !== 'none';
  
  if (isOnSale) {
    // Product is on sale - update sale price
    const salePriceElement = saleContainer.querySelector('.price-item--sale');
    if (salePriceElement) {
      salePriceElement.textContent = formattedPrice;
    }
    
    // Update compare-at price if available
    if (variantComparePrice && variantComparePrice !== 'null' && variantComparePrice !== '0') {
      const comparePriceInCents = parseInt(variantComparePrice);
      const comparePriceInPesos = Math.round(comparePriceInCents / 100);
      const formattedComparePrice = '$' + comparePriceInPesos.toLocaleString('es-CL') + ' CLP';
      
      const comparePriceElement = saleContainer.querySelector('.price-item--regular');
      if (comparePriceElement) {
        comparePriceElement.textContent = formattedComparePrice;
      }
    }
  } else {
    // Product is NOT on sale - update regular price
    const regularPriceElement = regularContainer?.querySelector('.price-item--regular');
    if (regularPriceElement) {
      regularPriceElement.textContent = formattedPrice;
    }
  }
}

// Global function for inline onchange events (backward compatibility)
function updateCardVariant(selectElement) {
  updateCardVariantPrice(selectElement);
}

// Initialize efficiently
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCardVariantSelectors);
} else {
  initCardVariantSelectors();
}

// Handle theme editor and dynamic content
document.addEventListener('shopify:section:load', initCardVariantSelectors);
document.addEventListener('slider:change', () => setTimeout(initCardVariantSelectors, 100));